import React from 'react';
import { EditSquareIcon } from '#/components/Icons/EditSquareIcon';
import { mergeSx } from '@jucy-ui/appearance';
import { TypographyProps } from '@mui/material';
import Typography from '@mui/material/Typography';
import Link, { LinkProps } from 'next/link';

export const BookingSummaryEditLink: React.FC<TypographyProps & Partial<LinkProps>> = ({ sx, href, ...props }) => (
    <Typography
        href={href || '#'}
        component={Link}
        shallow={false}
        sx={mergeSx(
            (theme) => ({
                fontSize: '0.875rem',
                fontWeight: 'bold',
                textDecoration: 'none',
                color: theme.colors.primary.main,
                display: 'block',
                '&:hover': {
                    color: theme.colors.primary.dark,
                    textDecoration: 'underline',
                },
            }),
            sx
        )}
        {...props}
    >
        Edit{' '}
        <EditSquareIcon
            sx={{
                fontSize: 20,
                verticalAlign: 'middle',
            }}
            className="icon"
        />
    </Typography>
);
